<div class="container" *ngVar="getTabs() as tabs" [ngClass]="{hidden: overlayIsHidden()}" (mousedown)="handleMouseDown($event)" (touchstart)="handleMouseDown($event)">
  <div *ngIf="tabs?.length > 1" class="tabs">
    <button mat-button class="tab" *ngFor="let tab of tabs" [ngClass]="{selected: tabIsSelected(tab), hidden: tabIsHidden(tab)}"
      (mousedown)="handleMouseDown($event)" (touchstart)="handleMouseDown($event)" (click)="selectTab(tab)">{{tab.name}}</button>
  </div>
  <div class="options">
    <div class="option-group" *ngFor="let groupName of getGroupNames()" [ngClass]="{collapsed: groupIsCollapsed(groupName)}">
      <div #header class="option-group-header" [ngClass]="{ hidden: headerIsHidden(groupName), selected: headerIsSelected(groupName) }" (mousedown)="handleMouseDown($event)" (touchstart)="handleMouseDown($event)" (click)="toggleGroupExpanded(groupName)">
        <span class="option-group-header-text">{{groupName}}</span>
        <img class="option-group-header-icon" src="assets/content-icon/ic-16.svg" />
      </div>
      <button #option mat-button class="option" *ngFor="let option of getGroupOptions(groupName)" [id]="getOptionElementId(option.id)" [ngClass]="{selected: optionIsSelected(option)}"
        (mousedown)="handleMouseDown($event)" (touchstart)="handleMouseDown($event)" (click)="chooseOption(option)">
        <span class="option-text">{{option.displayValue}}</span>
        <span *ngIf="option.secondaryDisplayValue" class="option-subtext">{{option.secondaryDisplayValue}}</span>
      </button>
    </div>
  </div>
</div>
